export interface WebhookLastEvent {
  createdAt: Date;
  status: "success" | "failed" | "pending";
}

export type WebhookTopic =
  | "return"
  | "label"
  | "shipment"
  | "consolidation_shipment"
  | "warehouse_return_processed";
export type WebhookKind = "redo" | "loop";

export interface Webhook {
  bearerToken: string;
  id: string | symbol;
  name: string;
  url: string;
  topic: WebhookTopic;
  kind: WebhookKind;
  status?: WebhookStatus;
  lastEvent?: WebhookLastEvent | null;
}

export enum WebhookStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export interface Client {
  id: string | symbol;
  name: string;
  bearerToken: string;
  teams: string[];
}

export interface DeveloperValue {
  webhooks: Webhook[];
  apiClients: Client[];
}

export interface WebhookValue {
  bearerToken: string;
  name: string;
  url: string;
  topic: WebhookTopic;
  kind: WebhookKind;
}

export interface ClientValue {
  name: string;
  bearerToken: string;
  teams: string[];
}
